import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ReflactTrainAuthCallbackRequest } from '@shared/index';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReflactTrainAuthService {
  private http = inject(HttpClient);

  public async authorizeReflactTrain(params: ReflactTrainAuthCallbackRequest): Promise<{ token?: string }> {
    return await firstValueFrom(this.http.post<{ token?: string }>('/api/callback/reflact-train', params));
  }

}

